import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPortfolioItems } from 'services/portfolios/service';

export const portfolioItems = createAsyncThunk('wizard/submitData', async () => {
    try {
        const res = await fetchPortfolioItems();
        return res;
    } catch {
        return [];
    }
});
